import React, { useState, useEffect } from 'react';

const navItems = [
  // { label: 'Overview', href: '#overview' },
  { label: 'About', href: '#about' },
  { label: 'Program', href: '#program' },
  { label: 'Registration', href: '#registration' },
  { label: 'Organizing Committee', href: '#speakers' },
  // { label: 'Partners', href: '#partners' },
  // { label: 'Venue', href: '#venue' },
  // { label: 'Abstract Submission', href: '#abstract' },
];

function Nav({ onLinkClick }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const handleLinkClick = (e) => {
    closeMenu();
    if (onLinkClick) onLinkClick();
  };

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('nav-menu-open');
    } else {
      document.body.classList.remove('nav-menu-open');
    }
    return () => document.body.classList.remove('nav-menu-open');
  }, [menuOpen]);

  return (
    <nav className="nav" aria-label="Main navigation">
      <button
        type="button"
        className="nav-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-expanded={menuOpen}
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        aria-controls="nav-menu"
      >
        <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} aria-hidden="true" />
      </button>
      <ul id="nav-menu" className="nav-list">
        {navItems.map((item) => (
          <li key={item.href}>
            <a href={item.href} className="nav-link" onClick={handleLinkClick}>
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Nav;
